/**
 * Company lead rules (viq-vault spec 2026-09-14-company-lead-rules-design §2.1).
 * Backend: viq-backend apps/superadmin-console/src/handlers/leadRules.ts —
 * GET gated `read Company`, PUT gated `update Company`.
 */
import type { LeadRulesResponse, SaveLeadRulesInput } from '@viq-admin/types';
import { superadminFetch } from './dataProvider';

function path(companyId: string): string {
  return `/v1/superadmin/companies/${encodeURIComponent(companyId)}/lead-rules`;
}

export function getCompanyLeadRules(companyId: string): Promise<LeadRulesResponse> {
  return superadminFetch<LeadRulesResponse>(path(companyId));
}

export function saveCompanyLeadRules(companyId: string, input: SaveLeadRulesInput): Promise<LeadRulesResponse> {
  return superadminFetch<LeadRulesResponse>(path(companyId), {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
